import Entity from "../../core/entity.js";
import GameEvent from "../../core/utils/game-event.js";

export default class Controller extends Entity {
  onLeft = new GameEvent();
  onRight = new GameEvent();
}